import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { esCantidadValida } from "../utils/productoSeleccionado.utils";

export const CeldaCantidadEditable = ({
    cantidad,
    deshabilitado,
    onCambiar,
}: {
    cantidad: number;
    deshabilitado?: boolean;
    onCambiar: (cantidad: number) => void;
}) => {
    const [texto, setTexto] = useState(String(cantidad));
    useEffect(() => setTexto(String(cantidad)), [cantidad]);

    return (
        <TextField
            variant="standard"
            type="number"
            size="small"
            value={texto}
            disabled={deshabilitado}
            inputProps={{ min: 1, step: 1, style: { textAlign: "center" } }}
            sx={{ width: 70 }}
            onChange={(e) => {
                setTexto(e.target.value);
                const n = Number(e.target.value);
                if (e.target.value.trim() !== "" && esCantidadValida(n)) onCambiar(n);
            }}
            onBlur={() => setTexto(String(cantidad))}
        />
    );
};